import Browser from '@mindful-web/marko-web/browser';
import Shared from '@media-matters/package-global/browser';

Shared(Browser);

export default Browser;
